import { cssVar } from '@chakra-ui/styled-system';

const $iconHeight = cssVar("icon-height");
const $iconWidth = cssVar("icon-width");
const iconSize = (size) => {
  return {
    [$iconHeight.variable]: `var(--vimeo-sizes-${size})`,
    [$iconWidth.variable]: `var(--vimeo-sizes-${size})`
  };
};
const Icon = {
  baseStyle: {
    height: [$iconHeight.reference],
    width: [$iconWidth.reference]
  },
  // Iris sizes
  sizes: {
    "2xs": iconSize("2xs"),
    xs: iconSize("xs"),
    sm: iconSize("sm"),
    md: iconSize("md"),
    lg: iconSize("lg"),
    xl: iconSize("xl"),
    "2xl": iconSize("2xl")
  },
  defaultProps: {
    size: "xs"
  }
};

export { Icon };
